import * as z from "zod";

export const TiktokAdsConnectionSchema = z.object({
  redoSegment: z.object({ name: z.string(), id: z.string() }),
  tiktokAdsCustomAudience: z.object({ name: z.string(), id: z.string() }),
});

export type TiktokAdsConnection = z.infer<typeof TiktokAdsConnectionSchema>;
